export function common() {

  const toggleHeaderBG = () => {
    let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    if(scrollTop > 1) {
      document.getElementsByTagName('header')[0].classList.add("active");
    } else {
      document.getElementsByTagName('header')[0].classList.remove("active");
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    toggleHeaderBG();
    window.onscroll = () => toggleHeaderBG();
  });

}


// WEBPACK FOOTER //
// ./assets/js/modules/common.js